<template>
    <section id="PatientInfo__Main">
        <section class="header-row align-items-center fw-bold">
            <span class="header-cell fw-bold user-name font-size-xl me-2">
                <a href="javascript:void(0);" @click="handlePatientNameClick()">
                    {{ selectedPatientDetails.lastName }}, {{ selectedPatientDetails.firstName }}
                </a>
            </span>
            <span class="header-cell fw-bold mt-sm-1 user-mrn" v-tooltip="{ title: 'Medical Record Number (MRN)' }">
                <label class="mb-0 mr-1">MRN:</label>
                <span>{{ selectedPatientDetails.patientIdNumber }}</span>
            </span>
        </section>
        <section class="header-row fw-bold font-size-xs">
            <span class="header-cell" v-tooltip="{ title: 'Sex' }">
                <span v-if="selectedPatientDetails.gender">
                    {{ selectedPatientDetails.gender }}
                </span>
                <span class="text-default" v-else>No Gender Selected</span>
            </span>
            <span class="header-cell" v-tooltip="{ title: 'Age' }">
                <i class="fas fa-circle header-divider"></i>
                <span v-if="age"> Age- {{ age }} </span>
                <span class="text-default" v-else>No Age added</span>
            </span>
            <span class="header-cell" v-if="selectedPatientDetails.isDNR">
                <i class="fas fa-circle header-divider"></i> <span class="badge CodeStatus__Red">DNR</span></span
            >
        </section>
        <section class="header-row font-size-xs">
            <div class="information-column d-flex flex-column me-4">
                <section class="information-cell">
                    <b class="title">Physician</b>
                    <div>
                        <EmptyTextHandler :text="selectedPatientDetails.physicianName" />
                    </div>
                </section>
                <section class="information-cell">
                    <b class="title">Phone</b>
                    <div>
                        <EmptyTextHandler :text="selectedPatientDetails.primaryPhone" />
                    </div>
                </section>
            </div>
            <div class="information-column d-flex flex-column me-4">
                <section class="information-cell">
                    <b class="title">DOB</b>
                    <div>
                        <EmptyTextHandler :text="moment(selectedPatientDetails.dob).format('MM/DD/YYYY')" />
                    </div>
                </section>
                <section class="information-cell">
                    <b class="title">Phone Type</b>
                    <div>
                        <EmptyTextHandler :text="selectedPatientDetails.phoneType" />
                    </div>
                </section>
            </div>
            <div class="information-column d-flex flex-column me-4">
                <section class="information-cell">
                    <b class="title">SOC</b>
                    <div>
                        <EmptyTextHandler :text="moment(selectedPatientDetails.startofCareDate).format('MM/DD/YYYY')" />
                    </div>
                </section>
                <section class="information-cell">
                    <b class="title">Medical</b>
                    <div>
                        {{ selectedPatientDetails.isNonMedical ? "No" : "Yes" }}
                    </div>
                </section>
            </div>
        </section>
    </section>
</template>

<style src="./HCPatientMain.scss"></style>
<script lang="ts" src="./HCPatientMain.ts"></script>
